export default class MobileService {
    isMobile() {
        return screen.width <= 760;
    }
}
